import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

type Props = {
  companyName: string;
  userName: string;
  userEmail: string;
};

const InvitationView = ({ companyName, userName, userEmail }: Props) => {
  const rows = [
    { label: 'Organization name', value: companyName },
    { label: 'Primary contact name', value: userName },
    { label: 'Primary contact email', value: userEmail },
  ];

  return (
    <Table>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.label}>
            <TableCell className="font-semibold w-47.5 text-slate-700">{row.label}</TableCell>
            <TableCell className="w-21.25">:</TableCell>
            <TableCell>{row.value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default InvitationView;
